import axios from "axios";
import {authHeader} from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;
  
const getEmployees = (params) => {
  return axios.get(API_URL + '/api/users', { 
    params: params,
    headers: authHeader() });
};

const getEmployeeByid = (params) => {
  return axios.get(API_URL + '/api/users/getuser', { 
    params: params,
    headers: authHeader() });
};

const getInactiveEmployees = (params) => {
  return axios.get(API_URL + '/api/users/inactive', { 
    params: params,
    headers: authHeader() });
};

const addEmployee = async (formData) => {
  const response = await axios.post(API_URL + "/api/users/register", formData, {  
    headers: authHeader()
  });
  return response.data;
};

const updateEmployee = async (r_id,  formData ) => {
  const response = await axios.put(API_URL + `/api/users/update/${r_id}`, formData, {
    headers: authHeader()
  });
  return response.data; 
};

const updateEmployeeByUser = async (r_id,  formData ) => {
  const response = await axios.put(API_URL + `/api/users/${r_id}`, formData, {
    headers: authHeader()
  });
  return response.data; 
};

const EMPLOYEEAPI={
  getEmployees,
  addEmployee,
  updateEmployee,
  getInactiveEmployees,
  getEmployeeByid,
  updateEmployeeByUser
}

export default EMPLOYEEAPI;